import { Injectable } from '@angular/core';
import { SideDialogService } from '../../ecaps-core/side-dialog/side-dialog.service';
import { LouverCertificationDialogComponent } from '../dialogs/louver-certification-dialog/louver-certification-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class LouverCertificationDialog {
  constructor(private sideDialogService: SideDialogService) {}

  show(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const dialogRef = this.sideDialogService.open(
        LouverCertificationDialogComponent,
        {
          disableClose: false,
          autoFocus: true,
          width: 1000,
        }
      );

      const subscription = dialogRef.closed.subscribe(
        () => {
          resolve(true);
        },
        null,
        () => {
          subscription.unsubscribe();
        }
      );
    });
  }
}
